import React, { Component } from "react"
import ReactDOM from "react-dom"
import _ from 'underscore'
import I18n from "../../utils/i18n.js"

import RangeSelector from '../../utils/range_selector'
import AccommodationsSelectedFacets from '../selected_facets'

import FacetSelect2 from '../../utils/facet_select2'

import SaleAdvancedFacetForm from '../forms/sale_advanced_facet_form'
import createReactClass from 'create-react-class'
export default createReactClass({
  getDefaultProps() {
    return {
      filters: [],
      results: 0,
      options: {},
      absolute_price_max: 1000000,
      place: null
    };
  },

  handleChange(e) {
    const self = this;
    const filters = {'booleans':[], 'languages':[], 'areas':[], 'object_types':[], 'subobject_types': []};

    //advanced form
    $.each(this.refs.advanced_form.refs, function(key, value) {
      const node = ReactDOM.findDOMNode(value);

      switch (key) {
        case 'maintenance':
        case 'object_sub_type':
        case 'rooms':
        case 'floors':
        case 'regions':
        case 'departments':
          const val = value.getValue();

          if (val) {
            filters[key] = val;
          }

          return;
      }
      switch (node.name) {
        case 'language':
          if (node.checked) { return filters['languages'].push(key); }
          break;
        case 'boolean':
          if (node.checked) { return filters['booleans'].push(key); }
          break;
        case 'areas':
          if (node.checked) { return filters['areas'].push(key); }
          break;
        case 'subobject_types':
          val = $(node).val();
          if (val != null) { return filters['departments'] = _.flatten([val]); }
          break;
        default:
          if (node.value !== "") { return filters[key] = node.value; }
      }
    });

    const min_plot_space =  this.refs.advanced_form.refs.plot_space.refs.range_min.getValue()
    const max_plot_space = this.refs.advanced_form.refs.plot_space.refs.range_max.getValue()
    const min_living_space = this.refs.advanced_form.refs.living_space.refs.range_min.getValue()
    const max_living_space = this.refs.advanced_form.refs.living_space.refs.range_max.getValue()
    const min_price = this.refs.price_range.refs.range_min.getValue()
    const max_price = this.refs.price_range.refs.range_max.getValue()

    if (/^\d+$/.test(min_price)) { filters['min_price'] = min_price; }
    if (/^\d+$/.test(max_price)) { filters['max_price'] = max_price; }
    if (/^\d+$/.test(min_plot_space)) { filters['min_plot_space'] = min_plot_space; }
    if (/^\d+$/.test(max_plot_space)) { filters['max_plot_space'] = max_plot_space; }
    if (/^\d+$/.test(min_living_space)) { filters['min_living_space'] = min_living_space; }
    if (/^\d+$/.test(max_living_space)) { filters['max_living_space'] = max_living_space; }

    filters['free_text'] = this.refs.free_text.value;
    const types = self.refs.object_type.getValue();

    if (types) { filters['object_types'] = types; }

    return this.props.onFormChange(filters);
  },

  handleFormChange(filters) {
    return this.props.onHandleFormChange(filters);
  },

  handleFormExpand(e) {
    $(".facets-inner").animate({ scrollTop:0 });

    const adverts_type = this.props.options.type;

    return $('.advanced-filters').slideToggle(function() {
      let text;
      if ($(this).is(':visible')) {
        text = `&#8722; ${I18n.t('search.less_filters')}`;
        $.cookie( adverts_type + '_expanded', true );
      } else {
        text = `&#43; ${I18n.t('search.more_filters')}`;
        $.cookie( adverts_type + '_expanded', false );
      }
      return $('.toggle-filters').html(text);
    });
  },

  render() {
    const filters = this.props.filters || {};
    const self = this;

    const min = filters['min_price'];
    const max = filters['max_price'];

    const object_types = self.props.options['object_types'].map(option => {
      return { value: option, label: I18n.t(`search.object_type.${option}`) }
    });
    const selected_object_types = self.props.filters !== null ? self.props.filters.object_types : undefined;

    const free_text = (this.props.filters && this.props.filters.free_text) || "";

    return <div>
      <div className={this.props.className}>
        <form ref='form' onChange={this.handleChange}>
          <div className='filters-top'>
            <div className='form-row'>
              <div className='form-cell'>
                <RangeSelector ref="price_range" key="price_range" options={self.props.options.price_options} onChange={this.handleChange} min={min} max={max} className='input--white' />
              </div>
              <div className='form-cell cell-33'>
                <FacetSelect2
                  ref="object_type"
                  value={selected_object_types}
                  options={object_types}
                  onChange={() => this.handleChange()}
                  multi={true}
                  placeholder={I18n.t('search.placeholders.object_type')}
                  className='object-type-dropdown input--white'
                />
              </div>
            </div>
          </div>

          <div className={`advanced-filters ${this.props.options.expanded ? 'show' : 'hidden'}`}>
            <SaleAdvancedFacetForm options={this.props.options} map={this.props.map} facets={this.props.facets} ref="advanced_form" filters={this.props.filters} form={self.refs['form']} onFormChange={self.handleChange} />
            <div className="form-row facets__search">
              <div className="form-cell cell-33">
                <label htmlFor="free_text" className="filter__label filter__label--indent">{I18n.t('search.form_labels.free_text')}</label>
              </div>
              <div className="form-cell">
                <input type='text' className='input--white' placeholder={I18n.t('search.placeholders.fulltext')} onChange={this.handleChange} key='free_text' id="free_text" ref='free_text' value={free_text}></input>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className="filter-results-top">
        <AccommodationsSelectedFacets blacklist={this.props.options.tags_blacklist} filters={this.props.filters} onDeselect={this.handleFormChange} options={this.props.options} />
        <div className='toggle-filters btn-cta' onClick={this.handleFormExpand}>
          {this.props.options.expanded ? (`- ${I18n.t('search.less_filters')}`) : (`+ ${I18n.t('search.more_filters')}`)}
        </div>
      </div>
    </div>;
  }
});
